import { FREE_EXTRAS_COPY, formatFreeExtrasDate, validFreeExtrasGift } from "@/lib/free-extras";
import { useI18n } from "@/lib/i18n";

export default function FreeExtrasGift({ gift }) {
  const { locale } = useI18n();
  const copy = FREE_EXTRAS_COPY[locale];
  if (!validFreeExtrasGift(gift)) return null;
  return (
    <section className="rounded-2xl border border-primary/20 bg-primary/5 p-4" aria-labelledby="free-extras-gift-heading">
      <h3 id="free-extras-gift-heading" className="font-semibold">{copy.giftTitle}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{copy.giftDescription}</p>
      <dl className="mt-3 grid gap-3 text-sm sm:grid-cols-2">
        {[["starts", gift.startsAt], ["ends", gift.endsAt]].map(([key, timestamp]) => (
          <div key={key}><dt className="text-muted-foreground">{copy[key]}</dt>
            <dd className="mt-1 font-medium"><time dateTime={new Date(timestamp * 1000).toISOString()}>{formatFreeExtrasDate(timestamp, locale)}</time></dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
